import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Futures = () => {
    const navigate = useNavigate();
    const { status } = useParams<{ status: string }>();
    const [showFallback, setShowFallback] = useState(false);
    const [platform, setPlatform] = useState<'android' | 'ios' | 'web'>('web');

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor;
        
        // Detect platform
        if (/android/i.test(userAgent)) {
            setPlatform('android');
            // Show fallback options for Android after a short delay
            const timer = setTimeout(() => {
                setShowFallback(true);
            }, 1000);
            return () => clearTimeout(timer);
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            setPlatform('ios');
            // Redirect iOS to App Store
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            setPlatform('web');
            // Redirect web to website
            window.location.href = "https://returns.trade";
        }
    }, []);

    const openApp = () => {
        // Try to open the app with the status from URL
        const statusParam = status || 'live'; // Default to 'live' if no status provided
        window.location.href = `returns://futures/${statusParam}`;
    };

    const downloadApp = () => {
        // Redirect to Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
    };

    // Don't render anything for iOS or web as they redirect immediately
    if (platform === 'ios' || platform === 'web') {
        return <h2>Redirecting...</h2>;
    }

    return (
        <div style={{ 
            textAlign: 'center', 
            padding: '50px 20px',
            fontFamily: 'Arial, sans-serif'
        }}>
            <h2>Opening Returns App...</h2>
            
            {showFallback && (
                <div style={{ marginTop: '30px' }}>
                    <p>If the app didn't open automatically, you can:</p>
                    <div style={{ marginTop: '20px' }}>
                        <button 
                            onClick={openApp}
                            style={{
                                padding: '12px 24px',
                                margin: '0 10px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '16px'
                            }}
                        >
                            Open App
                        </button>
                        <button 
                            onClick={downloadApp}
                            style={{
                                padding: '12px 24px',
                                margin: '0 10px',
                                backgroundColor: '#28a745',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '16px'
                            }}
                        >
                            Download App
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Futures;
